module.exports = __webpack_public_path__ + "static/img/a103.26d7a68a.png";